import { ApiTagsEnum } from '@/enum/apiTags.enum';

import {
  LoginUserBody,
  LoginWithTokenRes,
  ResetPasswordBody,
  ResetPasswordRes,
  SignUpRes,
  SignInRes,
  UserRegisterBody,
} from '@/types/domain';

import { api } from './api.service';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Used for SSO login (latvia, estonia tenants)
    loginWithToken: builder.mutation<LoginWithTokenRes, { token: string }>({
      query: (body) => ({
        url: '/auth/login-with-token',
        method: 'POST',
        body,
      }),
      invalidatesTags: [ApiTagsEnum.GET_USER_PROFILE],
    }),

    // Used for normal login (spain tenant)
    signIn: builder.mutation<SignInRes, LoginUserBody>({
      query: (body) => ({
        url: '/auth/login',
        body,
        method: 'POST',
      }),
      invalidatesTags: [ApiTagsEnum.GET_USER_PROFILE],
    }),
    signUp: builder.mutation<SignUpRes, UserRegisterBody>({
      query: (body) => ({
        url: '/auth/signup',
        body,
        method: 'POST',
      }),
    }),
    requestResetLink: builder.mutation<{ success: boolean }, { email: string }>(
      {
        query: (body) => ({
          url: '/auth/forgot-password',
          method: 'POST',
          body,
        }),
      },
    ),
    resetPassword: builder.mutation<ResetPasswordRes, ResetPasswordBody>({
      query: (body) => ({
        url: '/auth/renew-password',
        method: 'POST',
        body,
      }),
    }),

    // Used for generating tmp token for redirecting to game
    generateTmpToken: builder.mutation<{ token: string }, void>({
      query: () => ({
        url: '/auth/tmp-token',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useSignInMutation,
  useSignUpMutation,
  useGenerateTmpTokenMutation,
  useLoginWithTokenMutation,
  useRequestResetLinkMutation,
  useResetPasswordMutation,
} = authApi;
